import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import React, { Fragment, useRef, useState } from "react";
import { Helmet } from "react-helmet";

//store
import { useStore } from "src/store/Store";
import { updateUser } from "src/store/userReducer";

import mobiscroll from "@mobiscroll/react";
import { snackbar, toast } from "@mobiscroll/react5";
import line from "src/assets/Lines.svg";
import grid from "src/assets/grid.svg";
import login_icon from "src/assets/login icon  human.svg";
import doctor from "src/assets/login-doctor.svg";
import Loader from "src/components/Dashboard/common/Loader";
import "../Dashboard/Layouts/Card.css";
import "./Auth.scss";
import ChangeTempPassword from "./ChangeTempPassword";

import { useHistory } from "react-router-dom";
import signin_circle from "src/assets/signin-circle.svg";
import { getQuery, resetIdleTimer } from "../../components/ApolloConnection/ApolloProviderComponent";
import { getQuery as getQueryUnauthorized } from "../../components/ApolloConnection/UnauthorizedConnection/ApolloProviderSignup";
import "../ApolloConnection/UnauthorizedConnection/ApolloProviderSignup";
import "../ApolloConnection/UnauthorizedConnection/Credentials";
import { GET_FILE_FOR_DOCG, USER_DATA } from "../graphql/GraphQLquery";
import { fetchAuthSession, signIn, signOut, fetchMFAPreference, fetchUserAttributes, getCurrentUser, } from "aws-amplify/auth";
import SetMFAasTOTP from "./SetMFAasTOTP";
import OtpVerification from "./OtpVerification";
import { verifyTurnstileToken } from "src/components/Admin/Subscription/api";

const env = process.env.REACT_APP_ENVIRONMENT;
const SITE_KEY = process.env.REACT_APP_TURNSTILE_KEY;
const IS_PROD = env === 'PRODUCTION';

/** Hard timeout for silent Turnstile execute() before surfacing an error. */
const TURNSTILE_EXECUTE_TIMEOUT_MS = 20000;
/** Extended window when Cloudflare shows an interactive challenge the user must solve. */
const TURNSTILE_INTERACTIVE_TIMEOUT_MS = 120000;

/** Reject in-flight login captcha only; ignore idle widget errors (e.g. Strict Mode teardown). */
function settleTurnstileExecution(promiseRef, setIsCaptchaExecuting, outcome) {
  const pending = promiseRef.current;
  if (!pending) return false;
  if (pending.timeoutId) clearTimeout(pending.timeoutId);
  setIsCaptchaExecuting(false);
  if (outcome.reject) pending.reject(outcome.payload);
  else pending.resolve(outcome.payload);
  promiseRef.current = null;
  return true;
}

/** Arm (or re-arm) the pending-execution timeout that rejects with the user-facing timeout error. */
function armTurnstileTimeout(promiseRef, setIsCaptchaExecuting, ms) {
  return setTimeout(() => {
    if (!promiseRef.current) return;
    setIsCaptchaExecuting(false);
    promiseRef.current.reject({
      error: "timeout",
      message:
        "Security verification timed out. Please try logging in again. If this continues, please refresh the page.",
    });
    promiseRef.current = null;
  }, ms);
}

function SignIn() {
  const history = useHistory();
  const [user, setUser] = useState({});
  const [link, setLink] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [authenticating, setAuthenticating] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorLogin, setErrorLogin] = useState("");
  const [loader, setLoader] = useState(false);
  const [changeTempPassword, setChangeTempPassword] = useState(null);
  const [congnitoUser, setCognitoUser] = useState(null);
  const [authType, setAuthType] = useState(null);
  const { globalStateUser, dispatchUser } = useStore();
  const [userData, setUserData] = useState(null);
  const [mfa, setMfa] = useState(null);

  const isLoggingInRef = useRef(false); //to prevent multiple login attempts

  //captcha token state
  const turnstileRef = useRef(null);
  /** Widget id returned by `turnstile.render` (not the container element). */
  const turnstileWidgetIdRef = useRef(null);
  const [verifyingCaptcha, setVerifyingCaptcha] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);

  // New state variables for invisible captcha execution tracking
  const [isCaptchaExecuting, setIsCaptchaExecuting] = useState(false);
  const [isWidgetReady, setIsWidgetReady] = useState(false);
  const captchaExecutionPromiseRef = useRef(null);

  const checkMFA = async () => {
    const user = await getCurrentUser();
    setUserData(user);
    const mfa = await fetchMFAPreference();
    return mfa;
  };

  const minMaxLength = (text, minLength, maxLength) => {
    let result = !text || text.length < minLength;
    if (maxLength) result = result || text.length < minLength;
    return result;
  };

  const validEmail = (text) => {
    const regex = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    return !regex.test(text);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let currentFormErrors = {};

    switch (name) {
      case "username":
        setUser({ ...user, username: value });
        if (!value || validEmail(value)) {
          currentFormErrors[name] = `Email address is invalid`;
        } else {
          delete currentFormErrors[name];

          localStorage.setItem("username", value);
        }
        break;
      case "password":
        setUser({ ...user, password: value });
        if (minMaxLength(value, 8)) {
          currentFormErrors[name] = `Password should have minimum 8 characters`;
        } else {
          delete currentFormErrors[name];
        }
        break;
      default:
        break;
    }
    setFormErrors(currentFormErrors);
  };

  const forgotPassword = () => {
    history.push("/forgot-password");
  };

  //mock functions for local/staging development
  let verifyTurnstileOnServer = async (token) => ({ success: true });
  let executeCaptcha = () => Promise.resolve('dummy-token-local');

  if (IS_PROD) {

    // call backend to verify turnstile token
    verifyTurnstileOnServer = async function verifyTurnstileOnServer(token) {
      if (!token) return { success: false, error: 'missing-token', message: 'Security verification token is missing. Please try logging in again.' };

      try {
        setVerifyingCaptcha(true);
        setCaptchaError(null);

        const response = await verifyTurnstileToken({ token: token });

        setVerifyingCaptcha(false);

        // Handle undefined response (API error)
        if (!response) {
          return {
            success: false,
            error: 'network',
            message: 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.'
          };
        }

        // Check if response has success field
        if (response.success === true) {
          return { success: true, data: response };
        } else {
          // Extract error details from response
          const errorCode = response.error?.code || 'unknown';

          // Provide user-friendly messages based on error type
          let userMessage = 'Security verification failed. Please try logging in again.';

          if (errorCode === 'invalid-input-response' || errorCode === 'timeout-or-duplicate') {
            userMessage = 'Security verification expired. Please try logging in again.';
          } else if (errorCode === 'internal-error') {
            userMessage = 'Security verification encountered an error. Please refresh the page and try again.';
          } else if (errorCode === 'network') {
            userMessage = 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.';
          }

          return {
            success: false,
            error: errorCode,
            message: userMessage
          };
        }
      } catch (err) {
        setVerifyingCaptcha(false);
        console.error('Security verification error:', err);
        return {
          success: false,
          error: 'network',
          message: 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.'
        };
      }
    }

    // Execute Turnstile on demand (render uses execution: "execute").
    executeCaptcha = function executeCaptcha() {
      return new Promise((resolve, reject) => {
        const widgetId = turnstileWidgetIdRef.current;
        if (!isWidgetReady || !window.turnstile || !widgetId) {
          reject({
            error: "widget-not-ready",
            message:
              "Security check is still loading. Please wait a moment and try again. If this persists, please refresh the page.",
          });
          return;
        }

        const failStart = (message) => {
          if (captchaExecutionPromiseRef.current?.timeoutId) {
            clearTimeout(captchaExecutionPromiseRef.current.timeoutId);
          }
          setIsCaptchaExecuting(false);
          captchaExecutionPromiseRef.current = null;
          reject({
            error: "execution-error",
            message,
          });
        };

        setIsCaptchaExecuting(true);
        setCaptchaError(null);
        captchaExecutionPromiseRef.current = { resolve, reject };

        const timeoutId = armTurnstileTimeout(
          captchaExecutionPromiseRef,
          setIsCaptchaExecuting,
          TURNSTILE_EXECUTE_TIMEOUT_MS
        );
        captchaExecutionPromiseRef.current.timeoutId = timeoutId;

        const runExecute = (attempt) => {
          try {
            window.turnstile.execute(widgetId);
          } catch (err) {
            if (attempt < 1) {
              try {
                window.turnstile.reset(widgetId);
              } catch {
                /* ignore */
              }
              window.setTimeout(() => runExecute(attempt + 1), 50);
              return;
            }
            failStart(
              "Security verification failed to start. Please try logging in again. If this continues, please refresh the page."
            );
          }
        };

        try {
          window.turnstile.reset(widgetId);
        } catch {
          /* ignore */
        }
        window.setTimeout(() => runExecute(0), 0);
      });
    };
  }

  const login = async () => {
    // Validate form fields
    if (user.username == null || user.password == null) {
      setFormErrors({
        username: user.username ? undefined : "This field is required",
        password: user.password ? undefined : "This field is required",
      });
      return;
    }

    let captchaPassed = true;

    if (IS_PROD) {
      // Check if widget is ready
      if (!isWidgetReady) {
        setCaptchaError("Security check is still loading. Please wait a moment and try again. If this persists, please refresh the page.");
        return;
      }

      // Prevent double-clicking
      if (isCaptchaExecuting || verifyingCaptcha || authenticating) {
        return;
      }

      try {
        // Show toast notification - starting verification
        toast({
          message: "Verifying security...",
          color: "info"
        });

        // Step 1: Execute invisible security check to get fresh token
        setCaptchaError(null);
        const token = await executeCaptcha();

        // Show toast notification - verifying with server
        toast({
          message: "Completing security verification...",
          color: "info"
        });

        // Step 2: Immediately verify token with backend (don't cache it)
        const verification = await verifyTurnstileOnServer(token);

        if (!verification || !verification.success) {
          // Show user-friendly error with clear guidance
          setCaptchaError(verification?.message || "Security verification failed. Please try logging in again. If this continues, please refresh the page.");
          captchaPassed = false;

          // Reset widget for next attempt
          if (window.turnstile && turnstileWidgetIdRef.current) {
            try {
              window.turnstile.reset(turnstileWidgetIdRef.current);
            } catch {
              /* ignore */
            }
          }

        }

      } catch (error) {
        // Handle security check execution errors with clear guidance
        const errorMessage =
          error?.message ||
          "Security verification encountered an error. Please try logging in again. If this continues, please refresh the page.";
        setCaptchaError(errorMessage);
        captchaPassed = false;

        // Reset widget and state if possible
        if (window.turnstile && turnstileWidgetIdRef.current) {
          try {
            window.turnstile.reset(turnstileWidgetIdRef.current);
          } catch {
            /* ignore */
          }
        }
        setIsCaptchaExecuting(false);
      }
    }

    // Only proceed with sign-in if captcha logic passed (or if IS_PROD is false)
    if (!captchaPassed) {
      return;
    }

    toast({ message: "Authenticating", color: "success" });
    setAuthenticating(true);
    setErrorLogin("");

    // Proceed with sign-in
    _signIn(user.username, user.password);
  };

  async function onLogin() {
    setLoader(true);
    try {
      let response = await getQuery(USER_DATA);

      let roles = response.data.getUserInfo.data.roles[0];
      const { email, phone_number } = await fetchUserAttributes();
      const { userId } = await getCurrentUser();

      if (roles == "Doctor" || roles == "Admin") {
        // history.push("/clinic/dashboard");
        alert("Please Enter DOCG Admin Credentials.");
      } else {
        sessionStorage.setItem("userRole", roles);
        sessionStorage.setItem("loginStatus", true);
        sessionStorage.setItem("role-id", response?.data?.getUserInfo?.data?.profileId);

        dispatchUser(
          updateUser({
            userId,
            userMobile: phone_number,
            userEmail: email,
            loginStatus: true,
            userRoles: roles,
          })
        );
      }
    } catch (error) {
      snackbar({
        message: "Some error occurred while trying to login",
        color: "danger",
      });
      console.error("Error: ", error);
    }
    setLoader(false);
  }

  React.useEffect(() => {
    if (globalStateUser.loginStatus) {
      if (globalStateUser.userRoles == "SuperAdmin") history.push("/admin");
      else history.push("/clinics");
    }

  }, [globalStateUser]);

  // to clear any existing session - before signing in
  React.useEffect(() => {
    const clearExistingSession = async () => {
      try {
        if (isLoggingInRef.current) {
          console.log("Login in progress, skipping session clear");
          return;
        }

        const session = await fetchAuthSession({ forceRefresh: false }).catch(() => null);
        if (session) {
          await signOut(); // Clear any existing session
          console.log("Existing session cleared.");
        }
        sessionStorage.clear();
        localStorage.removeItem("_expiredTime");
      } catch (error) {
        console.error("Error clearing session:", error);
      }
    };

    clearExistingSession();
  }, []);

  async function _signIn(username, password) {
    isLoggingInRef.current = true;
    resetIdleTimer();
    setLoader(true);
    try {
      const { isSignedIn, nextStep } = await signIn({ username, password });
      if (nextStep.signInStep == "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
        // history.push("/change-password");
        setChangeTempPassword(user);
      } else if (
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE" ||
        nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION"
      ) {
        if (
          nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION" ||
          nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
        )
          setAuthType("TOTP");
        else setAuthType("SMS");
        setCognitoUser(user);
        // history.push("/otp-verification");
      } else {
        if (env !== "dev") {
          let mfa = await checkMFA();
          if (mfa === "NOMFA") {
            setMfa(true);
          } else onLogin();
        } else onLogin();
      }
    } catch (error) {
      setAuthenticating(false);
      snackbar({
        message: "Incorrect Username or Password",
        color: "danger",
      });
    }
    setLoader(false);
  }

  // Effect to render Turnstile — visible-on-demand when Cloudflare escalates a challenge
  React.useEffect(() => {
    if (IS_PROD) {
      let isMounted = true;
      let retryCount = 0;
      const maxRetries = 10;
      const retryInterval = 500; // 500ms between retries

      const initializeTurnstile = () => {
        if (!isMounted || !turnstileRef.current) return;

        if (turnstileWidgetIdRef.current && window.turnstile) {
          if (isMounted) {
            setIsWidgetReady(true);
            setCaptchaError(null);
          }
          return;
        }

        if (window.turnstile && turnstileRef.current) {
          try {
            const widgetId = window.turnstile.render(turnstileRef.current, {
              sitekey: SITE_KEY,
              size: "flexible",
              execution: "execute",
              appearance: "interaction-only",
              "before-interactive-callback": function () {
                const pending = captchaExecutionPromiseRef.current;
                if (!pending) return;
                if (pending.timeoutId) clearTimeout(pending.timeoutId);
                pending.timeoutId = armTurnstileTimeout(
                  captchaExecutionPromiseRef,
                  setIsCaptchaExecuting,
                  TURNSTILE_INTERACTIVE_TIMEOUT_MS
                );
              },
              callback: function (token) {
                if (!isMounted) return;
                setCaptchaError(null);
                settleTurnstileExecution(
                  captchaExecutionPromiseRef,
                  setIsCaptchaExecuting,
                  { payload: token }
                );
              },
              "expired-callback": function () {
                if (!isMounted) return;
                const handled = settleTurnstileExecution(
                  captchaExecutionPromiseRef,
                  setIsCaptchaExecuting,
                  {
                    reject: true,
                    payload: {
                      error: "expired",
                      message:
                        "Security verification expired. Please try logging in again.",
                    },
                  }
                );
                if (!handled) {
                  console.warn("[turnstile] Token expired before sign-in (ignored on idle widget).");
                }
              },
              "error-callback": function () {
                if (!isMounted) return;
                const handled = settleTurnstileExecution(
                  captchaExecutionPromiseRef,
                  setIsCaptchaExecuting,
                  {
                    reject: true,
                    payload: {
                      error: "captcha-error",
                      message:
                        "Security verification encountered an error. Please try logging in again. If this continues, please refresh the page.",
                    },
                  }
                );
                if (!handled) {
                  console.warn(
                    "[turnstile] Widget error before sign-in (ignored — often Strict Mode or transient load)."
                  );
                  if (window.turnstile && turnstileWidgetIdRef.current) {
                    try {
                      window.turnstile.reset(turnstileWidgetIdRef.current);
                    } catch {
                      /* ignore */
                    }
                  }
                }
              },
            });

            turnstileWidgetIdRef.current = widgetId;

            if (isMounted) {
              setIsWidgetReady(true);
              setCaptchaError(null);
            }
          } catch (err) {
            console.error("Error initializing Turnstile:", err);
            if (isMounted && retryCount < maxRetries) {
              retryCount++;
              setTimeout(initializeTurnstile, retryInterval);
            } else if (isMounted) {
              setCaptchaError(
                "Security check failed to load. Please refresh the page and try again."
              );
            }
          }
        } else {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(initializeTurnstile, retryInterval);
          } else if (isMounted) {
            setCaptchaError("Security check failed to load. Please refresh the page and try again.");
          }
        }
      };

      initializeTurnstile();

      return () => {
        isMounted = false;
        captchaExecutionPromiseRef.current = null;
        if (window.turnstile && turnstileWidgetIdRef.current) {
          try {
            window.turnstile.remove(turnstileWidgetIdRef.current);
          } catch (err) {
            console.warn("Turnstile remove on unmount:", err);
          }
          turnstileWidgetIdRef.current = null;
        }
        setIsWidgetReady(false);
        setIsCaptchaExecuting(false);
      };
    }
  }, [IS_PROD]);

  if (mfa) {
    return (
      <>
        <SetMFAasTOTP userData={userData} onSuccess={onLogin} />
      </>
    );
  }

  if (congnitoUser) {
    return (
      <>
        <Loader show={loader} />
        <OtpVerification
          cognitoObject={congnitoUser}
          onSuccess={onLogin}
          mfaType={authType}
        />
      </>
    );
  }

  if (changeTempPassword) {
    return <ChangeTempPassword user={changeTempPassword} />;
  }

  const download = async () => {
    const res = await getQueryUnauthorized(GET_FILE_FOR_DOCG);
    setLink(res?.data?.getFileForDocg?.data?.url);
  };

  return (
    <Fragment>
      <Loader show={loader} />

      <Helmet>
        <title>Login | DOCG</title>
      </Helmet>
      <div className="mbsc-grid">
        {/* <button onClick={download}>Download</button>
        <a href={link}>asdfdfg</a> */}
        <div className="mbsc-card main-card-wrapper">
          <div className="signup-wrapper">
            <div className="mbsc-row">
              <div className="mbsc-col-xl-6 doctor-images-left mbsc-col-12 p-0">
                <div className="left-signup-div"></div>
                <img src={doctor} className="left-signup-img" />
              </div>
              <div className="mbsc-col-xl-6 mbsc-col-12 signup-right">
                <img src={grid} className="grid-top" />
                <img src={signin_circle} className="signin-circle" />
                <div className="bottom-circle" />
                <div className="top-circle" />
                <div className="right-signup-div">
                  <div className="get-started-wrapper">
                    <p className="get-txt">Welcome Back!</p>
                    <p
                      style={{ color: "#757575" }}
                      className="signup-link mt-4"
                    >
                      To login, please enter your email and password
                    </p>
                    <p className="connect-txt"></p>
                    {/* <br /> */}
                    {/* <br /> */}
                    <br />
                    <div className="signup-wrapper-inner">
                      <mobiscroll.Input
                        inputStyle="underline"
                        labelStyle="floating"
                        placeholder=""
                        name="username"
                        type="email"
                        onChange={handleChange}
                        valid={!formErrors.username}
                        errorMessage={formErrors.username}
                        disabled={authenticating}
                      >
                        Enter Email Address *
                      </mobiscroll.Input>
                      <br />
                      <mobiscroll.Input
                        inputStyle="underline"
                        labelStyle="floating"
                        passwordToggle={true}
                        type="password"
                        name="password"
                        onChange={handleChange}
                        valid={!formErrors.password}
                        errorMessage={formErrors.password}
                        // disabled={authenticating}
                        className="input-style"
                        style={{ marginBottom: "10px" }}
                      >
                        Password *
                      </mobiscroll.Input>
                      <br />

                      {/* Turnstile captcha */}
                      {IS_PROD && (
                        <div style={{ margin: '16px 0' }}>
                          <div ref={turnstileRef}></div>
                          {
                            captchaError && (
                              <div style={{
                                color: 'red',
                                marginTop: 6,
                                fontSize: '14px',
                                fontWeight: '500'
                              }}>
                                {captchaError}
                              </div>
                            )
                          }
                          {
                            (isCaptchaExecuting || verifyingCaptcha) && (
                              <div style={{
                                color: '#6c5b7b',
                                marginTop: 6,
                                fontSize: '12px',
                                fontStyle: 'italic'
                              }}>
                                Verifying security...
                              </div>
                            )
                          }
                        </div>
                      )}


                      <button className="transparent-button" onClick={forgotPassword}>
                        Forgot Password?
                      </button>
                      <br />
                      <button
                        className="pink-button"
                        onClick={login}
                        disabled={
                          authenticating ||
                          IS_PROD && (isCaptchaExecuting || verifyingCaptcha || !isWidgetReady)
                        }
                      >
                        <img src={login_icon} />
                        &nbsp;&nbsp; Login
                      </button>
                      <br />

                      <p className="text-danger text-center">{errorLogin}</p>
                    </div>
                  </div>
                </div>
                <img
                  src={line}
                  className="lines-bottom"
                  style={{ marginLeft: "8%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default SignIn;
